var app = angular.module("leonardo");

var DynamicFormListFilters = function(
  $scope,
  SectorRestService,
  $controller,
  ClientInstanceService
) {

  $controller('FiltersBaseController', { $scope: $scope });

  $scope.types = [
    {id:'system', name:'System Forms'},
    {id:'account', name:'Account Forms'}
  ];

  const clientInstanceOptions = ClientInstanceService.getlist({ essential: true }).then(function (response) {
    return response.map(function (clientInstance) {
      return {
        id: clientInstance.id,
        name: `${clientInstance.name} (id: ${clientInstance.id})`
      };
    });
  });

  $scope.filters_options = [
    {
      group: 'hierarchy',
      name: 'By Hierarchy',
      elements: [
        {
          id: 'client_instances',
          name: 'Client Instance',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          required: false,
          placeholder: 'All Client Instances',
          condition: $scope.authDataService.isAdmin(),
          options: clientInstanceOptions,
          conflicts: ['account_reports', 'property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
        },
        {
          id: 'account_reports',
          name: 'Account',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Accounts',
          condition: $scope.filterService.accounts.length > 1 && $scope.authDataService.isNotStaff(),
          options: $scope.filterService.accounts,
          conflicts: ['client_instances', 'property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
        },
        {
          id: 'managed_by_reports',
          name: 'Management Company',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Management Companies',
          condition: $scope.filterService.managers.length > 1,
          options: $scope.filterService.managers,
          conflicts: ['client_instances', 'property_reports', 'portfolio_reports', 'group_reports', 'account_reports']
        }
      ]
    },
    {
      id: 'sector',
      name: 'Sector',
      label: null,
      inline: false,
      type: 'options',
      multiple: false,
      placeholder: 'Select sector',
      condition: ($scope.authDataService.isAdmin() || $scope.authDataService.isWhiteLabelAdmin()),
      service: SectorRestService,
      conflicts: ['category']
    },
    {
      id: 'origin',
      name: 'Type',
      label: null,
      inline: false,
      type: 'options',
      multiple: false,
      placeholder: 'Select Type',
      condition: $scope.authDataService.isNotStaff(),
      options: $scope.types,
      conflicts: []
    },
    {
      id: 'search',
      name: 'Dynamic Form Name',
      label: null,
      inline: false,
      type: 'text',
      placeholder: 'Dynamic Form Name',
      condition: true,
      conflicts: [],
      onSubmit: $scope.filter
    }
  ];

  $scope.filterService.showFilters(['origin', 'search']);

};

app.controller('DynamicFormListFilters', [
  '$scope',
  'SectorRestService',
  '$controller',
  'ClientInstanceService',
  DynamicFormListFilters
]);
